<template>
  <div style="margin-left: 180px;display: flex;height: 100px;white-space: nowrap;">
    <template v-if="fileList && fileList.length">
      <div class="picDiv" v-for="(file, index) in fileList" :key="index + file.name">
        <img class="width100" :src="getFileURL(file)" />
        <div class="hoverContainer">
          <div class="hoverDiv">
            <i class="el-icon-delete" @click="delFile(index)"></i>
          </div>
        </div>
      </div>
    </template>

    <template v-if="backFileList && backFileList.length">
      <div class="picDiv" v-for="(file, index) in backFileList" :key="index + file.address">
        <img :src="downloadUrl + file.address" class="width100" />
        <div class="hoverContainer">
          <div class="hoverDiv">
            <i class="el-icon-delete-solid" @click="_delFromServer(file.address)"></i>
          </div>
        </div>
      </div>
    </template>

    <div @click="uploadPic" :class="isDisabled ? 'hideDottedDiv' : 'dottedDiv'">
      <input ref="uploadPic" type="file" class="fileInput" @change="_handleChange" accept="image/*" />
      <i class="el-icon-plus uploadPic"></i>
    </div>
  </div>
</template>
<script>
import * as API from '../utils/apiService'
import { getFileURL } from '../utils/utils'
import config from '../config'

const { downloadUrl } = config

export default {
  name: 'imgUploader',
  props: [
    'fileList',
    'handleChange',
    'backFileList',
    'isDisabled',
    'delFromServer'
  ],
  data () {
    return {
      downloadUrl,
      file: {},
      fileName: '',
      fileUrl: ''
    }
  },
  methods: {
    getFileURL,
    _handleChange (e) {
      this.file = e.target.files[0]
      this.fileName = this.file.name
      this.fileUrl = this.getFileURL(this.file)
      this.handleChange(this.file)
    },
    uploadPic () {
      this.$refs.uploadPic.click()
    },
    delFile (index) {
      this.$confirm('确定删除该图片吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fileList.splice(index, 1)
        this.$refs.uploadFile.value = null
      })
    },
    _delFromServer (address) {
      this.$confirm('确定删除该图片吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          id: this.$route.query.id,
          address: address
        }
        API.deleteImageByPidAddress(params).then(resp => {
          if (resp.resultCode === '0000') {
            this.$message.success('删除成功！')
            this.delFromServer()
          }
        })
      })
    }
  }
}
</script>
<style lang="scss">
</style>
